import { Info, X } from 'lucide-react';
import { cn } from '../lib/cn';

export interface InfoBannerProps {
  children: React.ReactNode;
  onDismiss?: () => void;
  className?: string;
}

/** Информационная плашка по макетам РТК: синяя, с иконкой слева и крестиком закрытия справа. */
export function InfoBanner({ children, onDismiss, className }: InfoBannerProps) {
  return (
    <div
      className={cn('flex items-start gap-3 rounded-xl bg-info-soft px-4 py-3 text-sm text-fg', className)}
    >
      <Info className="mt-0.5 h-4 w-4 shrink-0 text-info" />
      <p className="min-w-0 flex-1">{children}</p>
      {onDismiss && (
        <button
          type="button"
          onClick={onDismiss}
          aria-label="Закрыть"
          className="shrink-0 text-fg-muted transition-colors hover:text-fg"
        >
          <X className="h-4 w-4" />
        </button>
      )}
    </div>
  );
}
